import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

export function SettingsSection({ id, icon: Icon, title, desc, children }: { id: string; icon: LucideIcon; title: string; desc: string; children: ReactNode }) {
  return (
    <section id={id} className="fade-up scroll-mt-24 rounded-[14px] border border-[#DDE1E8] bg-white p-5 sm:p-7" data-testid={`settings-section-${id}`}>
      <div className="mb-6 flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#1B2A4A] text-[#C9A84C]"><Icon className="h-5 w-5" /></span>
        <div>
          <h2 className="font-display text-lg font-bold text-[#1B2A4A]">{title}</h2>
          <p className="text-sm text-slate-500">{desc}</p>
        </div>
      </div>
      {children}
    </section>
  );
}

export function Field({ label, htmlFor, hint, children }: { label: string; htmlFor: string; hint?: string; children: ReactNode }) {
  return (
    <div className="min-w-0 space-y-1.5">
      <label htmlFor={htmlFor} className="text-sm font-medium text-slate-700">{label}</label>
      {children}
      {hint && <p className="text-xs text-slate-500">{hint}</p>}
    </div>
  );
}
